module.exports = __webpack_public_path__ + "img/logo5.33ffebb4.png";